<mat-select
  class="status-select"
  panelClass="finding-state-select-panel"
  hideSingleSelectionIndicator
  [class.disabled]="disabled()"
  [formField]="statusForm.status"
  [ngClass]="statusClass()"
  (selectionChange)="onStatusChange()"
>
  @for (statusOption of statusOptions; track statusOption) {
    <mat-option [value]="statusOption">
      {{ `model.finding.status.${statusOption}` | translate }}
    </mat-option>
  }
</mat-select>
